import { computed } from 'mobx';
import FileModel    from './globals/FileModel';

export default class ReportMediaModel extends FileModel {
  static get path() {
    return '/backend/report_media/{?id}';
  }

  @computed
  public get mediaFileName() {
    return this.get('mediaFileName');
  }

  @computed
  get objectUrl(): string {
    return this.get('objectUrl');
  }
}
